import React from 'react'

/* eslint import/no-webpack-loader-syntax: off */
import HorseImg from '!url-loader!./symbols/horse.svg'

export default function(props) {
    const message = props.message || 'Загрузка'
    return (
        <center>
            <div className="kudago-preloader-container">
                <div className="kudago-preloader">
                    <img src={HorseImg} title={message} alt={message}/>
                    <div className="kudago-preloader-border" />
                </div>
            </div>
            {message}
        </center>
    )
}
